import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
import * as i2 from "NewAngular/services/core/ajax.service";
export class FolderableAjaxService {
    constructor(urlsService, ajaxService) {
        this.urlsService = urlsService;
        this.ajaxService = ajaxService;
    }
    getFolderableItem(itemType, itemId) {
        const url = this.urlsService.getUrl(this.urlsService.FOLDERS.FOLDERABLE, { itemType, itemId });
        return this.ajaxService.getDataObserveBody(url);
    }
}
FolderableAjaxService.ɵfac = function FolderableAjaxService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableAjaxService)(i0.ɵɵinject(i1.UrlsService), i0.ɵɵinject(i2.AjaxService)); };
FolderableAjaxService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FolderableAjaxService, factory: FolderableAjaxService.ɵfac, providedIn: 'root' });
